<div
    class="help-orchestrator-modal"
    [class.help-orchestrator-modal--width-calendly]="viewModel().componentState === HelpOrchestratorStates.APPOINTMENT"
>
    @switch (viewModel().componentState) {
        @case (HelpOrchestratorStates.LOADING) {
            <div class="help-orchestrator-modal__loading">
                <eb-spinner />
            </div>
        }
        @case (HelpOrchestratorStates.APPOINTMENT) {
            <eb-request-commercial-appointement
                [calendlyUrl]="viewModel().calendlyUrl"
                [subtitle]="'help.appointment.subtitle'"
                [title]="'help.appointment.title'"
                (close)="close()"
                (setComponentState)="goBack()"
            />
        }
        @case (HelpOrchestratorStates.FORM) {
            <eb-help-contact-form
                [formContacts]="viewModel().formContacts"
                (back)="goBack()"
                (submitForm)="onFormSubmit($event)"
            />
        }
        @case (HelpOrchestratorStates.SUCCESS) {
            <eb-help-contact-form-success />
        }
        @case (HelpOrchestratorStates.FAILURE) {
            <div class="help-orchestrator-modal__failure">
                <eb-alert
                    type="error"
                    [text]="'help.failure.message' | transloco"
                />
                <button
                    eb-button
                    type="button"
                    [isV2]="true"
                    (click)="retry()"
                    color="primary-v2"
                    size="small"
                >
                    {{ 'help.failure.retry' | transloco }}
                </button>
            </div>
        }
        @default {
            <eb-help-option-selector
                [hasCalendly]="viewModel().hasCalendly"
                [hasFormContacts]="viewModel().hasFormContacts"
                (selectAppointment)="setComponentState(HelpOrchestratorStates.APPOINTMENT)"
                (selectForms)="setComponentState(HelpOrchestratorStates.FORM)"
            />
        }
    }
</div>
